import React, { Component } from 'react';
import classNames from 'classnames';
import MoVeInDesktopHeader from '../../../../../common/components/MoVeInDesktopHeader';
import MoVeInDesktopFooter from "../../../../../common/components/MoVeInDesktopFooter";
import RegForm from '../RegForm';
import RegCheckData from '../RegCheckData';
import RegDone from '../RegDone';

import './DesktopReg.css';

export default class DesktopReg extends Component {
  render() {
    const { step } = this.props;

    return (
      <div className="DesktopReg">
        <MoVeInDesktopHeader />
        <div className="RegSteps">
          <div className={classNames({ hiddenStep: step !== 'check' })}>
            <RegCheckData onConfirm={this.props.onConfirmData} withLegal={this.props.withLegal} />
          </div>
          <div className={classNames({ hiddenStep: step !== 'form' })}>
            <RegForm onClickReg={this.props.onClickReg} form={this.props.form} />
          </div>
          {step === 'done' && <RegDone />}
        </div>
        <MoVeInDesktopFooter />
      </div>
    );
  }
}
